import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'TEAM_INACTIVATE_ERROR':
      return action.error;
    case 'TEAM_INACTIVATE_RESET':
      return null;
    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'TEAM_INACTIVATE_LOADING':
      return action.loading;
    case 'TEAM_INACTIVATE_RESET':
      return false;
    default:
      return state;
  }
}

export function inactivated(state = null, action) {
  switch (action.type) {
    case 'TEAM_INACTIVATE_SUCCESS':
      return action.inactivated;
    case 'TEAM_INACTIVATE_RESET':
      return null;
    default:
      return state;
  }
}

export default combineReducers({ error, loading, inactivated });
